import React, { useState } from "react";
import "../css-dashboard/Dashboard.css";
import SidebarReceiver from "../../components/sidebar-dashboard/SidebarReceiver";
import ReceiverTripsConcludedNegotiations from "../../components/receiver-trips-negotiations/ReceiverTripsConcludedNegotiations";
import UseReceiverTripsNegotiations from "../../hooks/UseTripsNegotiations/UseReceiverTripsNegotiations";
import UseModalReceiverConfirmData from "../../hooks/UseModalReceiverConfirmData/UseModalReceiverConfirmData";
import ModalReceiverConfirmData from "../../components/modal-receiver-confirm-data/ModalReceiverConfirmData";

const DashboardReceiver = ({ menuOpen, setMenuOpen }) => {
  const {
    tripsNegotiations,
    loadingTripsNegotiations,
    refetchTripsNegotiations,
  } = UseReceiverTripsNegotiations();

  const {
    isOpenReceiverConfirmData,
    showSuccessScreenReceiverConfirmData,
    openModalReceiverConfirmData,
    closeModalReceiverConfirmData,
    selectedNegotiationReceiverConfirmData,
    actionTypeReceiverConfirmData,
    handleSubmit: handleSubmitReceiverConfirmData,
    loadingReceiverConfirmData,
    errorReceiverConfirmData,
    successReceiverConfirmData,
  } = UseModalReceiverConfirmData(() => {
    refetchTripsNegotiations();
  });

  return (
    <>
      <div className={`dashboard-container ${menuOpen ? "menu-open" : ""}`}>
        <SidebarReceiver menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main className="main-content">
          <div className="dashboard-header">
            <h1>Dashboard do Destinatário</h1>
            <p className="breadcrumb">
              <a href="/dashboard-receiver">Início</a> / Encomendas Recebidas
            </p>
          </div>

          <ReceiverTripsConcludedNegotiations
            tripsNegotiations={tripsNegotiations}
            loadingTripsNegotiations={loadingTripsNegotiations}
            onOpenReceiverConfirmModal={openModalReceiverConfirmData}
          />
        </main>
      </div>
      <ModalReceiverConfirmData
        isOpenReceiverConfirmData={isOpenReceiverConfirmData}
        showSuccessScreenReceiverConfirmData={
          showSuccessScreenReceiverConfirmData
        }
        closeModalReceiverConfirmData={closeModalReceiverConfirmData}
        selectedNegotiationReceiverConfirmData={
          selectedNegotiationReceiverConfirmData
        }
        actionTypeReceiverConfirmData={actionTypeReceiverConfirmData}
        handleSubmit={handleSubmitReceiverConfirmData}
        loadingReceiverConfirmData={loadingReceiverConfirmData}
        errorReceiverConfirmData={errorReceiverConfirmData}
        successReceiverConfirmData={successReceiverConfirmData}
      />
    </>
  );
};

export default DashboardReceiver;
